import { api } from '@/services/api';
import { unifiedServices } from '@/services/unifiedService';
import { isSupabaseMode } from '@/config/dataSource';
import { Consultor } from '../types/consultor';

export class ConsultoresService {
  private static readonly BASE_URL = '/api/consultores';

  static async listarConsultores(tenantId?: string | number): Promise<Consultor[]> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.listarConsultores(tenantId);
    }
    try {
      const { data } = await api.get<Consultor[]>(this.BASE_URL);
      return data;
    } catch (error: any) {
      throw new Error('Erro ao listar consultores: ' + error.message);
    }
  }

  static async buscarConsultor(id: string): Promise<Consultor> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.buscarConsultor(id);
    }
    try {
      const { data } = await api.get<Consultor>(`${this.BASE_URL}/${id}`);
      return data;
    } catch (error: any) {
      throw new Error('Erro ao buscar consultor: ' + error.message);
    }
  }

  static async criarConsultor(consultor: Omit<Consultor, 'id' | 'created_at' | 'updated_at'>): Promise<Consultor> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.criarConsultor(consultor);
    }
    try {
      const { data } = await api.post<Consultor>(this.BASE_URL, consultor);
      return data;
    } catch (error: any) {
      throw new Error('Erro ao criar consultor: ' + error.message);
    }
  }

  static async atualizarConsultor(id: string, consultor: Partial<Consultor>): Promise<Consultor> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.atualizarConsultor(id, consultor);
    }
    try {
      const url = `${this.BASE_URL}/${id}`;
      const { tenant_id, ...payload } = consultor;
      console.log('Fazendo PUT para URL:', url);
      console.log('Dados enviados:', payload);
      const { data } = await api.put<Consultor>(url, payload);
      return data;
    } catch (error: any) {
      console.error('Erro na requisição PUT:', error);
      throw new Error('Erro ao atualizar consultor: ' + error.message);
    }
  }

  static async excluirConsultor(id: string): Promise<void> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.excluirConsultor(id);
    }
    try {
      await api.delete(`${this.BASE_URL}/${id}`);
    } catch (error: any) {
      throw new Error('Erro ao excluir consultor: ' + error.message);
    }
  }

  static async listarEquipe(supervisorId: string, tenantId?: string | number): Promise<{ lideres: Consultor[], relacionadores: Consultor[] }> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.listarEquipe(supervisorId, tenantId);
    }
    try {
      const { data } = await api.get<{ lideres: Consultor[], relacionadores: Consultor[] }>(
        `${this.BASE_URL}/${supervisorId}/equipe`
      );
      return data;
    } catch (error: any) {
      throw new Error('Erro ao listar equipe: ' + error.message);
    }
  }

  static async listarRelacionadores(liderId: string, tenantId?: string | number): Promise<Consultor[]> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.listarRelacionadores(liderId, tenantId);
    }
    try {
      const { data } = await api.get<Consultor[]>(`${this.BASE_URL}/${liderId}/relacionadores`);
      return data;
    } catch (error: any) {
      throw new Error('Erro ao listar relacionadores: ' + error.message);
    }
  }

  static async listarSupervisores(tenantId?: string | number): Promise<Consultor[]> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.listarSupervisores(tenantId);
    }
    try {
      const { data } = await api.get<Consultor[]>(`${this.BASE_URL}/supervisores`);
      return data;
    } catch (error: any) {
      throw new Error('Erro ao listar supervisores: ' + error.message);
    }
  }

  static async ativarConsultor(id: string): Promise<Consultor> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.ativarConsultor(id);
    }
    try {
      const { data } = await api.post<Consultor>(`${this.BASE_URL}/${id}/ativar`);
      return data;
    } catch (error: any) {
      throw new Error('Erro ao ativar consultor: ' + error.message);
    }
  }

  static async inativarConsultor(id: string): Promise<Consultor> {
    if (isSupabaseMode()) {
      return await unifiedServices.consultores.inativarConsultor(id);
    }
    try {
      const { data } = await api.post<Consultor>(`${this.BASE_URL}/${id}/inativar`);
      return data;
    } catch (error: any) {
      throw new Error('Erro ao inativar consultor: ' + error.message);
    }
  }
} 